var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.appLoading)?_c('div',{staticClass:"telecom-story"},[_c('story-viewer',{attrs:{"pages":_vm.pages,"story-name":"TelecomStory","segment-extra-props":_vm.segmentExtraProps}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }